import { Link } from "react-router-dom";

const categories = [
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "动漫资讯",
    desc: "新番情报、剧场版、行业动态，第一时间掌握。",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    to: "/works",
    icon: "ri-movie-2-line",
    title: "作品推荐",
    desc: "动画与漫画精选，按类型地区年份轻松筛选。",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    to: "/analysis",
    icon: "ri-search-eye-line",
    title: "剧情解析",
    desc: "伏笔梳理、主题探讨，读懂故事背后的设计。",
    accent: "bg-secondary-100 text-secondary-700",
  },
  {
    to: "/culture",
    icon: "ri-book-open-line",
    title: "动漫文化",
    desc: "发展历史、名家介绍、周边文化专题合集。",
    accent: "bg-accent-100 text-accent-700",
  },
];

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((category) => (
        <Link
          key={category.to}
          to={category.to}
          className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
        >
          <span
            className={`mb-4 flex h-11 w-11 items-center justify-center rounded-md ${category.accent}`}
          >
            <i className={`${category.icon} text-2xl`} />
          </span>
          <h3 className="text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {category.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
            进入频道
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
          </span>
        </Link>
      ))}
    </div>
  );
}